import { ICustomerAccount } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TGetCustomerAccountsRequestSchema } from "./getCustomerAccountsSchema";

export const getCustomerAccounts = (axios: IAxiosInstance) => {
  return async (
    params: Omit<
      TGetCustomerAccountsRequestSchema,
      "company_id" | "partner_id"
    > & { companyID: string }
  ) => {
    const response = await axios.noRetry.get<IApiResponse<ICustomerAccount[]>>(
      `/customer-accounts`,
      {
        params,
      }
    );

    return response.data;
  };
};
